import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    taskTracking: (idTask) =>
      `${baseURL}/api/task/${encodeURIComponent(idTask)}`
  }
})(process.env.BEASYNCTASKS_URL)

export const beAsyncTaskGetTaskDetails = (idTask) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.taskTracking(idTask),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(({ data }) => data)
}
